require('../../../modules/es.string.starts-with');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').startsWith;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/string/virtual/starts-with.js
// module id = 1006
// module chunks = 0